<template>
  <div class="custom-locale-control-edit-popup-container"
    v-bind="$attrs"
    @click.stop
  >
    <div class="custom-locale-control-edit-popup-title"
      v-move="titleDrag"
      @mousedown="moveFlagChange(true)"
      @mouseup="moveFlagChange(false)"
    >
      <div class="title">
        {{ title }}
      </div>
      <div class="control">
        <span
          v-for="(control, index) of controls"
          :key="index"
          :title="control.title"
        >
          <svg-icon
            :iconName="control['loading']?'loading':control.iconName"
            :fillColor="control.fill"
            @click="(!control['loading']) && control.onClick(target, btn, control)"
          ></svg-icon>
        </span>
      </div>
    </div>
    <div class="custom-locale-control-edit-popup-body">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, defineComponent,
  useAttrs,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import SvgIcon from '@/components/SvgIcon';

// props
const props = defineProps({
  title: { type: String, },
  controls: { type: Array, default: ()=> [], },
  target: { type: Object, },
  btn: { type: Object, },
  titleDrag: { type: Boolean, default: ()=> false, },
});
// emit
const emit = defineEmits([
  
]);

const moveFlag = ref(false),
      moveFlagChange = (flag)=>{
        moveFlag.value = flag;
      }

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.custom-locale-control-edit-popup-container{
  border-radius: var(--borderRadiusSize_3);
  padding: var(--padDefaultSize_2);
  background-color: var(--backgroundColor_25);
  height: max-content;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.1);
  border: 1px solid var(--borderColor_3);
  width: max-content;
  .custom-locale-control-edit-popup-body{
    // padding-top: 5px;
    height: max-content;
    // background-color: var(--backgroundColor_16);
    border-radius: var(--borderRadiusSize_3);
  }
  .custom-locale-control-edit-popup-title{
    display: flex;
    // height: 20px;
    line-height: 22px;
    .title{
      min-width: 0;
      flex: 1;
      font-size: 12px;
      font-weight: bold;
      color: var(--fontColor_27);
      text-align: left;
    }
    .control{
      width: max-content;
      display: flex;
      gap: 5px;
      .svg-icon{
        height: 20px;
        aspect-ratio: 1/1;
        cursor: pointer;
      }
    }
  }
}
</style>